import { isNative, isLink } from '@/apis/platform/getMenu';
import { TabNavItemType, TabNavItemTarget } from '@/components/slide-menu/tab-nav';
import type { MenuItem } from '@/apis/platform/getMenu';

// newtab refresh norefresh ...
const itemTargets = ['', TabNavItemTarget.blank, '', '', '', '', ''];
/**
 * 转换接口 @/apis/platform/getMenu 中的菜单数据为slideMenu可用数据
 *
 * @param menus
 * @param currentPageConfigPath
 */
function transformPlantformMenu(menus: MenuItem[], currentPageConfigPath: string, params: string = '') {
  // 去除配置中最后的*号，*为什么要去掉？
  if (currentPageConfigPath[currentPageConfigPath.length - 1] === '*')
    currentPageConfigPath = currentPageConfigPath.slice(0, -1);

  const menuItems = menus.map((item) => {
    let jumpUrl = getJumpUrl(item);

    return {
      ...item,
      title: ((item as unknown) as { title: string }).title || item.name,
      getLink: ((item as unknown) as any).getLink || (() => jumpUrl),
      target: itemTargets[item.jumpType],
      itemType: isLink(item) ? TabNavItemType.link : TabNavItemType.native,
    };
  });

  // 根据MenuItem获取侧边栏跳转链接
  function getJumpUrl(menuItem: MenuItem) {
    const isNativeView = isNative(menuItem);
    let { jumpUrl, url, path = '' } = menuItem;

    if (jumpUrl) return jumpUrl;

    // jumpUrl没有，需要根据path来生成jumpUrl
    if (!jumpUrl) {
      if (!isNativeView) {
        // 前期jumpUrl填写在url中，优先级jumpUrl大于url
        jumpUrl = jumpUrl || url;
      } else {
        // 内部实现依赖配置的path或者本地配置的path
        jumpUrl = (currentPageConfigPath + '/' + path + params)
          .split('/')
          // 过滤空节点
          .filter((item) => !!item)
          .join('/');
        jumpUrl = '/' + jumpUrl;
        // path中的最后一个*需要去掉，并保留最后的/
        jumpUrl = jumpUrl[jumpUrl.length - 1] === '*' ? jumpUrl.slice(0, -1) : jumpUrl;
      }
    }

    return jumpUrl;
  }

  return menuItems;
}

export { transformPlantformMenu };
